// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgTransactionsController = function ($scope, $http, PaymentGatewayTransactions, PaymentGatewayTransactionsUtils) {

    $scope.loading = true;
    
    // enum values.
    $scope.transactionStatuses = [];
    $scope.paymentProviders = [];
    $scope.paymentRoles = [];
    $scope.transactionTypes = [];

    const getEmptyFilter = function () {
        return {
            PaymentProvider: '',
            PaymentProviderRole: '',
            TransactionType: '',
            SearchIdentifier: '',
            CurrentStatus: '',
            After: '',
            Before: '',
        };
    };

    $scope.transactionFilter = getEmptyFilter();

    $scope.loadPage = function () {

        $http.get('/api/v1/paymentGateway/transactions/Statuses', {cache: true}).then(function (result) {
            $scope.transactionStatuses = result.data;
        });

        $http.get('/api/v1/paymentGateway/transactions/PaymentProviders', {cache: true}).then(function (result) {
            $scope.paymentProviders = result.data;
        });

        $http.get('/api/v1/paymentGateway/transactions/PaymentRoles', {cache: true}).then(function (result) {
            $scope.paymentRoles = result.data;
        });

        $http.get('/api/v1/paymentGateway/transactions/Types', {cache: true}).then(function (result) {
            $scope.transactionTypes = result.data;
        });
    }

    $scope.loadPage();

    $scope.fetchTransactions = function () {
        $scope.loading = true;
        $scope.transactions = $scope.paginator(function(options, callback) {
                return PaymentGatewayTransactions.query(options, function() 
                { 
                    callback();
                    $scope.loading = false;
                });
            },
            $scope.transactionFilter,
            100);
    }

    $scope.fetchTransactions();

    $scope.resetFilter = function () {
        $scope.transactionFilter = getEmptyFilter();
    };

    $scope.getCurrentStatusTimestamp = function (transaction){
        return transaction.States[transaction.States.length - 1].LastSeenAt;
    }

    $scope.identifyTransactionType = function (transaction) {
        return PaymentGatewayTransactionsUtils.identifyTransactionType(transaction);
    }
    
    $scope.getBillwerkTransactionId = function (transaction) {
        return transaction.BillwerkTransactionId.Value.split('-').slice(-1)[0];
    }

    $scope.getBillwerkTransactionId = function (transaction) {
        switch (PaymentGatewayTransactionsUtils.identifyTransactionType(transaction))
        {
            case 'Refund': return transaction.TargetPaymentTransactionId.Value.split('-').slice(-1)[0];
            default: return transaction.BillwerkTransactionId.Value.split('-').slice(-1)[0];;
        }
    }
};

PgTransactionsController.$inject = ["$scope", "$http", "PaymentGatewayTransactions", "PaymentGatewayTransactionsUtils"];
